import React, { Fragment, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import Loader from '../../layout/loader'
import swal from 'sweetalert';
import { Typography } from '@material-ui/core'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import DeleteIcon from '@mui/icons-material/Delete';
import CallMadeIcon from '@mui/icons-material/CallMade';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import emptyImage from '../../images/undraw_Empty_re_opql.png'
import { REMOVE_PRODUCT_REQUEST_RESET } from '../../redux/constants/wishListConstant';
import { clearErrorAction, allProductToWishListAction, removeProductToWishListAction } from '../../redux/actions/wishListAction'
import { cartAction } from '../../redux/actions/cartAction';
import Navbar from '../HomeScreen/Navbar';
import Footer from '../HomeScreen/bottomsection/Footer'
import MetaTag from '../../layout/MetaTag';
import AuthenticatedPage from './AuthenticatedPage';
import { textRapForNameSearch } from '../../utils/textRapUtils'


import './wishList.css'
function WishListProduct() {
    const dispatch = useDispatch();
    // redux functions
    const { user, isAuthenticated } = useSelector(state => state.user)
    const { loading, wishListProducts } = useSelector(state => state.wishListAll)
    const { loading: removeLoading, error: removeError, isProductRemove } = useSelector(state => state.wishListRemove)


    useEffect(() => {

        if (removeError) {
            swal({
                title: "Validation",
                text: removeError,
                icon: "error",
            })
            dispatch(clearErrorAction())
        }

        if (isProductRemove) {
            swal({
                title: "Removed",
                text: 'Your favorite item has removed',
                icon: "success",
            })
            dispatch({ type: REMOVE_PRODUCT_REQUEST_RESET })
        }


        dispatch(allProductToWishListAction())
    }, [dispatch, isProductRemove, removeError])


    const wishListRemoveHandler = (id) => {
        dispatch(removeProductToWishListAction(id))
    }

    const moveToCartHandler = (item) => {
        dispatch(cartAction(
            item.product,
            1,
            item.size || 0,
            item.colour || "Default",
            "0",
            0
        ));
        dispatch(removeProductToWishListAction(item._id));
        swal({
            title: "Moved to Bag",
            text: `${item.name || "Item"} has been moved to your shopping bag!`,
            icon: "success",
            timer: 2000,
            buttons: false,
        });
    };





    return (
        <Fragment>
            {isAuthenticated === true ? (<Fragment>
                <MetaTag
                    title={`${user.firstName}'s Wishlist | IM Online Shop`}
                    description="Your saved shoes and sneakers at IM Online Shop."
                    robots="noindex, nofollow"
                />
                {loading ? <Loader /> : (<Fragment>
                    <Navbar />
                    <main className="wishlist-page">
                        <div className="wishlist-heading-div">
                            <div className="wishlist-heading-copy">
                                <span>Saved For Later</span>
                                <h1>My Wishlist</h1>
                                <p>Keep your favourite pairs ready for the next drop, price check, or quick checkout.</p>
                            </div>
                            <div className="wishlist-hero-panel">
                                <div className="icons-div">
                                    <FavoriteBorderIcon />
                                </div>
                                <strong>{wishListProducts ? wishListProducts.length : 0}</strong>
                                <span>Saved items</span>
                            </div>
                        </div>

                        {wishListProducts && wishListProducts.length === 0 ? (<Fragment>
                            <div className="empty-image-div">
                                <img src={emptyImage} alt="Empty wishlist" />
                                <div className="paragraph-of-empty-div">
                                    <Typography> <h2>Your wishlist is empty</h2></Typography>
                                    <p>Save sneakers, loafers, boots, and daily pairs here while you compare.</p>
                                    <Link to="/Product" className="wishlist-empty-shop-btn">
                                        Start Shopping <ShoppingBagOutlinedIcon />
                                    </Link>
                                </div>
                            </div>
                        </Fragment>) : (<Fragment>
                            {removeLoading ? <Loader /> : (<Fragment>
                                <div className="wishlist-toolbar">
                                    <div>
                                        <strong>{wishListProducts && wishListProducts.length}</strong>
                                        <span>products saved in your wishlist</span>
                                    </div>
                                    <Link to="/Product">Continue shopping</Link>
                                </div>

                                <div className="wishlist-product-div">
                                    {wishListProducts && wishListProducts.map((product) => (
                                        <article className="wishlist-main-container" key={product._id}>
                                            <Link to={`/ProductDetail/${product.product}`} className="wishlist-image-section">
                                                {product.image ? (
                                                    <img src={product.image} alt={product.name} />
                                                ) : (
                                                    <span>No image</span>
                                                )}
                                            </Link>
                                            <div className="wishlist-details-section">
                                                <span className="wishlist-card-kicker">Saved item</span>
                                                <Link to={`/ProductDetail/${product.product}`} className="wishlist-product-name">
                                                    {textRapForNameSearch(product.name)}
                                                </Link>
                                                <div className="wishlist-product-price">
                                                    <CurrencyRupeeIcon /> {product.price}
                                                </div>

                                                <div className="wishlist-btns-sections">
                                                    <button
                                                        type="button"
                                                        onClick={() => moveToCartHandler(product)}
                                                        className="wishlist-product-view-btn"
                                                        style={{
                                                            background: "#111111",
                                                            color: "#ffffff",
                                                            border: "none",
                                                            cursor: "pointer",
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: "6px"
                                                        }}
                                                    >
                                                        Move to Cart <ShoppingBagOutlinedIcon fontSize="small" />
                                                    </button>
                                                    <Link to={`/ProductDetail/${product.product}`} className="wishlist-product-view-btn">
                                                        View Pair <CallMadeIcon />
                                                    </Link>
                                                    <button onClick={() => wishListRemoveHandler(product._id)} className="wishlist-product-delete-btn" aria-label={`Remove ${product.name} from wishlist`}>
                                                        <DeleteIcon />
                                                    </button>
                                                </div>
                                            </div>
                                        </article>
                                    ))}
                                </div>
                            </Fragment>)}
                        </Fragment>)}
                    </main>
                    <Footer />
                </Fragment>)}
            </Fragment>) : (<Fragment>
                <Navbar />
                <AuthenticatedPage />
                <Footer />
            </Fragment>)}

        </Fragment>
    )
}

export default WishListProduct
